import ForgotPassword from "../components/auth/ForgotPassword";

const ForgotPasswordPage = () => {
    return ( 
        <div>
            <ForgotPassword />
        </div>
     );
}
 
export default ForgotPasswordPage;